import { TFunction } from "react-i18next";
import { TerminalApi, TerminalType } from "../../../../../../../../../services/Api/Organization/types";

export type TerminalToUpdate = {
	accessAmount: number;
	propertyAmount: number;
	type: TerminalType;
};

export const getTerminalVersion = (terminal: TerminalApi): string => {
	if (terminal.app_version_code)
		return `${terminal.app_version}(${terminal.app_version_code}) ${terminal.system_type}`;
	return `${terminal.app_version} ${terminal.system_type}`;
};

export const getTerminalTypeTitle = (type: TerminalType, t: TFunction) => {
	switch (type) {
		case TerminalType.POS:
			return t("enums.terminal.type.POS_TERMINAL");
		case TerminalType.POS_MOBILE:
			return t("enums.terminal.type.TERMINAL_MOBILE");
		case TerminalType.KDS:
			return t("enums.terminal.type.TERMINAL_KDS");
		case TerminalType.KIOSK:
			return t("enums.terminal.type.TERMINAL_KIOSK");
		case TerminalType.KDS_NUMBER:
			return t("enums.terminal.type.KDS_NUMBER");
		default:
			return "";
	}
};
